import { axios } from '@/utils/request'

export function LandTrustWebPage(parameter) {
  return axios({
    url: '/LandTrust/web/page',
    method: 'get',
    params: parameter
  })
}

export function LandTrustWebDetail(parameter) {
    return axios({
      url: '/LandTrust/web/detail',
      method: 'get',
      params: parameter
    })
  }
